import { z } from "zod";
import apiClient from "../../../shared/api/client";
import type { PlansListResponse, UpdatePlanData } from "../types";

const planSchema = z.object({
  id: z.string(),
  localPlanId: z.string().nullable(),
  key: z.string().nullable(),
  name: z.string(),
  type: z.enum(["dedicated", "lite"]).nullable(),
  monthlyPrice: z.coerce.number(),
  currency: z.string(),
  cores: z.number().nullable(),
  ram: z.number().nullable(),
  bandwidth: z.number().nullable(),
  maxPlatforms: z.number().nullable(),
  videoQuality: z.string().nullable(),
  videoBitrate: z.number().nullable(),
  weeklyStreamingHours: z.number().nullable(),
  tier: z.number().nullable(),
  isActive: z.boolean(),
  creemProductId: z.string().nullable(),
  metadata: z.record(z.string()),
});

const plansListResponseSchema = z.object({
  data: z.array(planSchema),
});

export const fetchPlans = async (): Promise<PlansListResponse> => {
  const response = await apiClient.get("/plans");
  return plansListResponseSchema.parse(response.data);
};

export const updatePlan = async (
  id: string,
  data: UpdatePlanData,
): Promise<void> => {
  await apiClient.patch(`/plans/${id}`, data);
};
